import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelonFormModule, WidgetRegistry } from '@delon/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DndModule } from '../ngx-drag-drop';
import { DSharedModule } from '../shared/shared.module';
import { DynamicComponentModule, DynamicComponentRegistryService } from '../dynamic-component';
import { SHARED_DELON_MODULES } from '../shared-delon.module';
import { SHARED_ZORRO_MODULES } from '../shared-zorro.module';
import { RWidgetFormRenderComponent } from './common-component/r-widget-form-render/r-widget-form-render.component';
import { RWidgetFormItemComponent } from './common-component/r-widget-form-item/r-widget-form-item.component';
import { RWidgetFormComponent } from './r-widget-form/r-widget-form.component';
import { RWidgetButtonComponent } from './common-component/r-widget-button/r-widget-button.component';
import { WidgetRenderModule } from './widget-render';

const COMPONENTS = [
  RWidgetFormRenderComponent,
  RWidgetFormItemComponent,
  RWidgetFormComponent,
  RWidgetButtonComponent,
  RWidgetFormComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DndModule,
    DelonFormModule,
    DSharedModule,
    DynamicComponentModule,
    WidgetRenderModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class FormRenderModule {
  constructor() {}
}
